import { post } from "@insite/client-framework/Services/ApiService";
import { ImprovePageFormFields } from "@steiner/App/Components/ImprovePageLink/ImprovePageLinkModal";

const submitPageFeedbackUri = "/api/str/pagefeedback/submit";

export async function submitPageFeedbackService(data: ImprovePageFormFields) {
    try {
        const pageFeedbackResult = await post(`${submitPageFeedbackUri}`, data);
        return {
            result: pageFeedbackResult,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
